import { Icon } from 'components/Icon';
import React from 'react';
import styled from 'styled-components';

interface StopThubmnailProps {
  onClick?: () => void;
  isClickable?: boolean;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
}
const StopThumbnail = ({
  onClick,
  isClickable,
  onMouseOver,
  onMouseOut,
}: StopThubmnailProps) => (
  <StyledMapPin
    onClick={onClick}
    $isClickable={isClickable}
    onMouseOver={onMouseOver}
    onMouseOut={onMouseOut}
  >
    <Icon type="pin" width={20} offset={[8, 7]} color="gray7" />
  </StyledMapPin>
);

export default StopThumbnail;

const StyledMapPin = styled.div<{ $isClickable?: boolean }>`
  border-radius: 4px;
  background-color: #f0f0f0;
  width: 36px;
  height: 36px;
  ${({ $isClickable }) => $isClickable && 'cursor: pointer;'};
`;
